import Extension from './Extension';

export default class ExtensionMission {
  constructor(
    public id: number,
    public content: string,
    public createdAt: Date,
    public updatedAt: Date,
    public writerExtension: Extension,
  ) {}
}
